import { Modal, Typography } from '@automata/ui';
import { Stack } from '@mui/material';
import { FC } from 'react';

import { DataFieldForm } from './DataFieldForm';
import type { AdditionalDataInput } from '../../../../types';

export interface AddDataFieldModalProps {
  open: boolean;
  onClose: () => void;
  onAdd: (field: AdditionalDataInput) => void;
  existingFieldIds: string[];
}

export const AddDataFieldModal: FC<AddDataFieldModalProps> = ({
  open,
  onClose,
  onAdd,
  existingFieldIds,
}) => {
  return (
    <Modal open={open} onClose={onClose} title="Add new data field">
      <Stack gap={1} alignItems="flex-start">
        <Typography variant="body2" color="text.secondary">
          Set up additional information required for this data field.
        </Typography>

        <DataFieldForm
          onSubmit={onAdd}
          onCancel={onClose}
          existingFieldIds={existingFieldIds}
        />
      </Stack>
    </Modal>
  );
};
